// services/projectService.js
import axiosInstance from "./axiosInstance";

// =============================
// 📌 LẤY DANH SÁCH DỰ ÁN (có phân trang & filter)
// GET /api/projects?search=&page=&limit=
// =============================
export const getAllProjects = async (filters = {}, page = 1, limit = 10) => {
    const queryParams = new URLSearchParams({ ...filters, page, limit });
    const res = await axiosInstance.get(`/projects?${queryParams.toString()}`);
    // backend hiện tại trả về mảng trực tiếp
    return res.data;
};

// =============================
// 📌 LẤY DỰ ÁN THEO ID
// GET /api/projects/:id
// =============================
export const getProjectById = async (id) => {
  const res = await axiosInstance.get(`/projects/${id}/properties`);
  return res.data.properties ?? [];
};


export const uploadPropertyImages = async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file) => formData.append("images", file));

    const res = await axiosInstance.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    // Trả về mảng URL
    return res.data.urls || [];

};

// =============================
// 📌 TẠO DỰ ÁN MỚI (hỗ trợ FormData nếu có upload ảnh)
// POST /api/projects
// =============================
export const createProject = async (projectData) => {
    const res = await axiosInstance.post("/projects", projectData);
    return res.data;
};

// =============================
// 📌 CẬP NHẬT DỰ ÁN
// PUT /api/projects/:id
// =============================
export const updateProject = async (id, projectData) => {
    const res = await axiosInstance.put(`/projects/${id}`, projectData);
    return res.data; // project object trực tiếp
};

// =============================
// 📌 XÓA DỰ ÁN (Soft Delete)
// DELETE /api/projects/:id
// =============================
export const deleteProject = async (id) => {
    const res = await axiosInstance.delete(`/projects/${id}`);
    return res.data; // { message: "Xóa dự án thành công" }
};

// =============================
// 📌 LẤY DỰ ÁN THEO USER
// GET /api/projects/by-user/:userId
// =============================
export const getProjectsByUserId = async (userId, filters = {}, page = 1, limit = 10) => {
    const params = { ...filters, page, limit };
    const res = await axiosInstance.get(`/projects/by-user/${userId}`, { params });
    return res.data; // { projects: [...], total, totalPages }
};

// =============================
// 📌 CẬP NHẬT TRẠNG THÁI DỰ ÁN (approve/reject)
// PUT /api/projects/:id/status
// =============================
export const updateProjectStatus = async (id, status) => {
    const res = await axiosInstance.put(`/projects/${id}/status`, { status });
    return res.data; // project object sau khi update
};
